import React, { Component } from "react";
import axios from "axios";

export class Step7Review extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,

      // Selected Package Details
      packageDetails: null,
      loadingPackage: true,
    };
  }

  componentDidMount() {
    this.loadPackage();
  }

  loadPackage = async () => {

    try {

      const response = await axios.post(
        "https://idealtechnoride.in/api/package",
        {
          package_id: this.props.formData.internshipPackage,
        }
      );

      if (
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {

        this.setState({
          packageDetails: response.data[0],
          loadingPackage: false,
        });

      } else {

        this.setState({
          loadingPackage: false,
        });

      }

    } catch (error) {

      console.log(error);

      this.setState({
        loadingPackage: false,
      });

    }

  };

  handleSubmit = async () => {

    const data = this.props.formData;

    const formData = new FormData();

    // ============================
    // Upload Attachment
    // ============================

    if (data.attachment) {
      formData.append("imageUpload[]", data.attachment);
    }

    // ============================
    // Student Information
    // ============================

    formData.append("student_full_name", data.fullName || "");
    formData.append("student_email", data.email || "");
    formData.append("student_mobile", data.mobile || "");
    formData.append("student_college", data.college || "");
    formData.append("student_course", data.course || "");
    formData.append("student_year", data.year || "");
    formData.append("student_city", data.city || "");

    // ============================
    // Internship Details
    // ============================

    formData.append(
      "student_internship_domain",
      data.internshipDomain || ""
    );

    formData.append(
      "student_technology",
      Array.isArray(data.technology)
        ? data.technology.join(", ")
        : data.technology || ""
    );

    formData.append(
      "student_internship_duration",
      data.internshipDuration || ""
    );

    formData.append(
      "student_internship_mode",
      data.internshipMode || ""
    );

    formData.append(
      "student_preferred_batch",
      data.preferredBatch || ""
    );

    formData.append(
      "student_joining_date",
      data.joiningDate || ""
    );

    formData.append(
      "student_internship_package",
      data.internshipPackage || ""
    );

    // ============================
    // Project Details
    // ============================

    formData.append(
      "student_project_type",
      data.projectType || ""
    );

    formData.append(
      "student_project_category",
      data.projectCategory || ""
    );

    formData.append(
      "student_source_code",
      data.sourceCode || "No"
    );

    formData.append(
      "student_black_bound_report",
      data.blackBoundReport || "No"
    );

    formData.append(
      "student_viva_guidance",
      data.vivaGuidance || "No"
    );

    formData.append(
      "student_resume_guidance",
      data.resumeGuidance || "No"
    );

    formData.append(
      "student_placement_support",
      data.placementSupport || "No"
    );

    formData.append(
      "student_additional_requirement",
      data.additionalRequirement || ""
    );

    formData.append("student_status", "Pending");
    formData.append("student_remark", "");

    this.setState({
      loading: true,
    });

    try {

      const response = await axios.post(
        "https://idealtechnoride.in/api/main/add/student_costing",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);

      if (
        response.data.status === 1 ||
        response.data.status === "1" ||
        response.data.status === true
      ) {

        this.setState({
          loading: false,
        });

        if (typeof this.props.resetForm === "function") {

          this.props.resetForm(
            response.data.message ||
            "Internship Request Submitted Successfully."
          );

        } else {

          console.error("resetForm is not a function");

        }

      } else {

        this.setState({
          loading: false,
        });

        alert(
          response.data.message ||
          response.data ||
          "Submission Failed"
        );

      }

    } catch (error) {

      console.error(error);

      if (error.response) {
        console.log(error.response.data);
      }

      this.setState({
        loading: false,
      });

      alert("Server Error");
    }
  };

    render() {

    const data = this.props.formData;

    return (

      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-success text-white">

            <h3 className="mb-0">
              Step 7 : Review & Submit
            </h3>

          </div>

          <div className="card-body">

            <div className="alert alert-success">
              Please review all your details before submitting your internship request.
            </div>

            {/* Student Information */}

            <div className="card mb-4">

              <div className="card-header bg-light">
                <strong>Student Information</strong>
              </div>

              <div className="card-body">

                <div className="row">

                  <div className="col-md-6 mb-2">
                    <strong>Full Name :</strong><br />
                    {data.fullName || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Email :</strong><br />
                    {data.email || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Mobile :</strong><br />
                    {data.mobile || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>College :</strong><br />
                    {data.college || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Course :</strong><br />
                    {data.course || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Year :</strong><br />
                    {data.year || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>City :</strong><br />
                    {data.city || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Attachment :</strong><br />
                    {data.attachment
                      ? data.attachment.name
                      : "-"}
                  </div>

                </div>

              </div>

            </div>

            {/* Internship Details */}

            <div className="card mb-4">

              <div className="card-header bg-light">
                <strong>Internship Details</strong>
              </div>

              <div className="card-body">

                <div className="row">

                  <div className="col-md-6 mb-2">
                    <strong>Internship Domain :</strong><br />
                    {data.internshipDomain || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Technology :</strong><br />
                    {Array.isArray(data.technology)
                      ? data.technology.join(", ")
                      : data.technology || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Duration :</strong><br />
                    {data.internshipDuration || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Mode :</strong><br />
                    {data.internshipMode || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Preferred Batch :</strong><br />
                    {data.preferredBatch || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Joining Date :</strong><br />
                    {data.joiningDate || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Selected Package :</strong><br />
                    {this.state.packageDetails
                      ? this.state.packageDetails.package_name
                      : data.internshipPackage || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Package Price :</strong><br />
                    {this.state.packageDetails
                      ? `₹${Number(
                          this.state.packageDetails.package_price
                        ).toLocaleString()}`
                      : "-"}
                  </div>

                </div>

              </div>

            </div>

            {/* Project Details */}

            <div className="card mb-4">

              <div className="card-header bg-light">
                <strong>Project Details</strong>
              </div>

              <div className="card-body">

                <div className="row">

                  <div className="col-md-6 mb-2">
                    <strong>Project Type :</strong><br />
                    {data.projectType || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Project Category :</strong><br />
                    {data.projectCategory || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Source Code :</strong><br />
                    {data.sourceCode || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Black Bound Report :</strong><br />
                    {data.blackBoundReport || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Viva Guidance :</strong><br />
                    {data.vivaGuidance || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Resume Guidance :</strong><br />
                    {data.resumeGuidance || "-"}
                  </div>

                  <div className="col-md-6 mb-2">
                    <strong>Placement Support :</strong><br />
                    {data.placementSupport || "-"}
                  </div>

                </div>

                <hr />

                <strong>Additional Requirement</strong>

                <p className="mt-2">
                  {data.additionalRequirement || "-"}
                </p>

              </div>

            </div>

                        {/* Included in Internship Package */}

            <div className="card mb-4">

              <div className="card-header bg-warning">
                <strong>Included in Internship Package</strong>
              </div>

              <div className="card-body">

                {this.state.loadingPackage ? (

                  <div className="text-center py-3">

                    <div
                      className="spinner-border text-warning"
                      role="status"
                    >
                      <span className="visually-hidden">
                        Loading...
                      </span>
                    </div>

                    <p className="mt-2 mb-0">
                      Loading Package Details...
                    </p>

                  </div>

                ) : this.state.packageDetails ? (

                  <>

                    <div className="row mb-3">

                      <div className="col-md-4">

                        <strong>Package</strong>

                        <div>
                          {this.state.packageDetails.package_name}
                        </div>

                      </div>

                      <div className="col-md-4">

                        <strong>Package Tag</strong>

                        <div>
                          {this.state.packageDetails.package_tag}
                        </div>

                      </div>

                      <div className="col-md-4">

                        <strong>Price</strong>

                        <div className="text-success fw-bold">
                          ₹
                          {Number(
                            this.state.packageDetails.package_price
                          ).toLocaleString()}
                        </div>

                      </div>

                    </div>

                    <hr />

                    <h6 className="mb-3">
                      Package Features
                    </h6>

                    <div className="row">

                      {Array.isArray(
                        this.state.packageDetails.feature
                      ) &&
                        this.state.packageDetails.feature.map(
                          (item) => (

                            <div
                              className="col-md-6 mb-2"
                              key={item.feature_id}
                            >
                              ✅ {item.feature_name}
                            </div>

                          )
                        )}

                    </div>

                  </>

                ) : (

                  <div className="alert alert-danger mb-0">

                    Package details not found.

                  </div>

                )}

              </div>

            </div>

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
                disabled={this.state.loading}
              >
                Previous
              </button>

              <button
                className="btn btn-success"
                onClick={this.handleSubmit}
                disabled={this.state.loading}
              >
                {this.state.loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  "Submit Request"
                )}
              </button>

            </div>

          </div>

        </div>

      </div>

    );
  }
}

export default Step7Review;